(function () {
    'use strict';

    angular
        .module('core.components')
        .controller('ResetPasswordController', ResetPasswordController)

    /** @ngInject */
    function ResetPasswordController($state, $stateParams, sweetAlert, AuthenticationService, HelperService, PersonService) {
        const vm = this;

        vm.passwordValidator = AuthenticationService.passwordValidator;

        vm.recoverPassword = () => {
            HelperService.startLoading('.loading-holder');

            const changePasswordData = {
                Document: vm.resetData.Login,
                Token: $stateParams.t,
                Password: Encrypt.Hash(vm.resetData.Password).toString()
            }

            PersonService
                .changePassword(changePasswordData)
                .then(() => {
                    vm.step = 2;
                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        vm.startRecoverPassword = () => {
            vm.step = 2;
        }

        init();

        function init() {
            if (!$stateParams.t) {
                sweetAlert.swal({
                    title: 'Ops',
                    text: 'Ocorreu um erro ao recuperar os dados da página, tente novamente!',
                    type: 'info',
                    confirmButtonText: 'Ir para o Login',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(() => {
                    $state.go('app-auth.login');
                })
            } else
                vm.step = 1;
        }
    }
}());